export const images = [
    {
        src: require("../../assets/gallery/00s/1.jpg"),
        caption: "2003 - Sarah Kelman née Harland (MEng Aeronautics 1993). She took up gliding in '91 whilst at Imperial, and started competition flying the following year. Sarah was Women's European Champion in '99 and Women's World Champion in '01 and '07."
    },
];
